<template>
  <div class="oneui">
    <div></div>
    <div>
      <ul class="nameWrapper" :style="`grid-template-columns: 1fr;`">
        <li></li>
        <li class="current">
          <span>{{$t('pages.settings.legal')}}</span>
        </li>
        <li></li>
      </ul>
    </div>
    <div class="pageWrapper">
      <div class="page">
        <div class="ul">
          <div class="c8" scrollable>
            <p class="c1">
              <span class="c0">Chore Champion PRIVACY POLICY</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >Chore Champion (the &ldquo;Company &rdquo;) is committed to maintaining robust privacy protections for its users. &nbsp;Our Privacy Policy (&ldquo;Privacy Policy &rdquo;) is designed to help you understand how we collect, use and safeguard the information you provide to us and to assist you in making informed decisions when using our Service. &nbsp;</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >For purposes of this Agreement, &ldquo;Site &rdquo;refers to the Company &rsquo;s website, which can be accessed at chorechampionapp.com or through our mobile application.</span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >&ldquo;Service &rdquo;refers to the Company &rsquo;s services accessed via the Site, in which users can assign chore and purchase rewards.</span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >The terms &ldquo;we,&rdquo;&ldquo;us,&rdquo;and &ldquo;our &rdquo;refer to the Company.</span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >&ldquo;You &rdquo;refers to you, as a user of our Site or our Service.</span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >By accessing our Site or our Service, you accept our Privacy Policy and Terms of Use (found here: http://chorechampionapp.com/#/legal/), and you consent to our collection, storage, use and disclosure of your Personal Information as described in this Privacy Policy.</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1">
              <span class="c0">I. INFORMATION WE COLLECT</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1">
              <span>We collect &ldquo;Non-Personal Information &rdquo;and &ldquo;Personal Information.&rdquo;</span>
              <span class="c3">Non-Personal Information</span>
              <span>&nbsp;includes information that cannot be used to personally identify you, such as anonymous usage data, general demographic information we may collect, referring/exit pages and URLs, platform types, preferences you submit and preferences that are generated based on the data you submit and number of clicks.</span>
              <span class="c3">Personal Information</span>
              <span
                class="c0"
              >&nbsp;includes your your Google Account and children &rsquo;s names and ages.</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1 c7">
              <span>1. &nbsp;</span>
              <span class="c4">Information collected via Technology</span>
            </p>
            <p class="c1 c2 c7">
              <span class="c4"></span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >To activate the Service you do not need to submit any Personal Information other than your your Google Account and children &rsquo;s names and ages. To use the Service thereafter, you will not need to submit further Personal Information. However, in an effort to improve the quality of the Service, we track information provided to us by your browser or by our software application when you view or use the Service, such as the website you came from (known as the &ldquo;referring URL &rdquo;), the type of browser you use, the device from which you connected to the Service, the time and date of access, and other information that does not personally identify you. We track this information using cookies, or small text files which include an anonymous unique identifier. Cookies are sent to a user &rsquo;s browser from our servers and are stored on the user &rsquo;s computer hard drive. Sending a cookie to a user &rsquo;s browser enables us to collect Non-Personal information about that user and keep a record of the user &rsquo;s preferences when utilizing our services, both on an individual and aggregate basis. For example, the Company may use cookies to collect the following information:</span>
            </p>
            <p class="c1">
              <span class="c0">Information about login settings, account info and page states.</span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >The Company may use both persistent and session cookies; persistent cookies remain on your computer after you close your session and until you delete them, while session cookies expire when you close your browser.</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1 c7">
              <span>2. &nbsp;</span>
              <span class="c4">Information you provide us by registering for an account</span>
            </p>
            <p class="c1 c7 c2">
              <span class="c4"></span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >In addition to the information provided automatically by your browser when you visit the Site, to become a subscriber to the Service you will need to create a personal profile. You can create a profile by registering with the Service and entering your email address, and creating a user name and a password. By registering, you are authorizing us to collect, store and use your email address in accordance with this Privacy Policy.</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1 c6">
              <span>3.</span>
              <span class="c4">Children &rsquo;s Privacy</span>
            </p>
            <p class="c1 c6 c2">
              <span class="c4"></span>
            </p>
            <p class="c1">
              <span>The Site and the Service are directed to anyone under the age of 13.</span>
              <span
                class="c0"
              >The Site does not knowingly collect or solicit information from anyone under the age of 13, or allow anyone under the age of 13 to sign up for the Service. In the event that we learn that we have gathered personal information from anyone under the age of 13 without the consent of a parent or guardian, we will delete that information as soon as possible. If you believe we have collected such information, please contact us at legal@chorechampionapp.com.</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1">
              <span class="c0">II. HOW WE USE AND SHARE INFORMATION</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1">
              <span class="c4">Personal Information:</span>
            </p>
            <p class="c1 c2">
              <span class="c4"></span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >Except as otherwise stated in this Privacy Policy, we do not sell, trade, rent or otherwise share for marketing purposes your Personal Information with third parties without your consent. We do share Personal Information with vendors who are performing services for the Company, such as the servers for our email communications who are provided access to user &rsquo;s email address for purposes of sending emails from us. Those vendors use your Personal Information only at our direction and in accordance with our Privacy Policy.</span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >In general, the Personal Information you provide to us is used to help us communicate with you. For example, we use Personal Information to contact users in response to questions, solicit feedback from users, provide technical support, and inform users about promotional offers.</span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >We may share Personal Information with outside parties if we have a good-faith belief that access, use, preservation or disclosure of the information is reasonably necessary to meet any applicable legal process or enforceable governmental request; to enforce applicable Terms of Service, including investigation of potential violations; address fraud, security or technical concerns; or to protect against harm to the rights, property, or safety of our users or the public as required or permitted by law.</span>
            </p>
            <p class="c1 c2">
              <span class="c4"></span>
            </p>
            <p class="c1">
              <span class="c4">Non-Personal Information:</span>
            </p>
            <p class="c1 c2">
              <span class="c4"></span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >In general, we use Non-Personal Information to help us improve the Service and customize the user experience. We also aggregate Non-Personal Information in order to track trends and analyze use patterns on the Site. This Privacy Policy does not limit in any way our use or disclosure of Non-Personal Information and we reserve the right to use and disclose such Non-Personal Information to our partners, advertisers and other third parties at our discretion.</span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >In the event we undergo a business transaction such as a merger, acquisition by another company, or sale of all or a portion of our assets, your Personal Information may be among the assets transferred. You acknowledge and consent that such transfers may occur and are permitted by this Privacy Policy, and that any acquirer of our assets may continue to process your Personal Information as set forth in this Privacy Policy. If our information practices change at any time in the future, we will post the policy changes to the Site so that you may opt out of the new information practices. We suggest that you check the Site periodically if you are concerned about how your information is used.</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1">
              <span class="c0">III. HOW WE PROTECT INFORMATION</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >We implement security measures designed to protect your information from unauthorized access. Your account is protected by your account password and we urge you to take steps to keep your personal information safe by not disclosing your password and by logging out of your account after each use. We further protect your information from potential security breaches by implementing certain technological security measures including encryption, firewalls and secure socket layer technology. However, these measures do not guarantee that your information will not be accessed, disclosed, altered or destroyed by breach of such firewalls and secure server software. By using our Service, you acknowledge that you understand and agree to assume these risks.</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1">
              <span class="c0">IV. YOUR RIGHTS REGARDING THE USE OF YOUR PERSONAL INFORMATION</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >You have the right at any time to prevent us from contacting you for marketing purposes. &nbsp;When we send a promotional communication to a user, the user can opt out of further promotional communications by following the unsubscribe instructions provided in each promotional e-mail. You can also indicate that you do not wish to receive marketing communications from us in the Settings &gt;Account &gt;Manage Experience &gt;Marketing &gt;Emails section of the Site. Please note that notwithstanding the promotional preferences you indicate by either unsubscribing or opting out in the Settings &gt;Account &gt;Manage Experience &gt;Marketing &gt;Emails of the Site, we may continue to send you administrative emails including, for example, periodic updates to our Privacy Policy.</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1">
              <span class="c0">V. LINKS TO OTHER WEBSITES</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >As part of the Service, we may provide links to or compatibility with other websites or applications. However, we are not responsible for the privacy practices employed by those websites or the information or content they contain. This Privacy Policy applies solely to information collected by us through the Site and the Service. Therefore, this Privacy Policy does not apply to your use of a third party website accessed by selecting a link on our Site or via our Service. To the extent that you access or use the Service through or on another website or application, then the privacy policy of that other website or application will apply to your access or use of that site or application. We encourage our users to read the privacy statements of other websites before proceeding to use them.</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1">
              <span class="c0">VI. CHANGES TO OUR PRIVACY POLICY</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >The Company reserves the right to change this policy and our Terms of Service at any time. &nbsp;We will notify you of significant changes to our Privacy Policy by sending a notice to the primary email address specified in your account or by placing a prominent notice on our site. Significant changes will go into effect 30 days following such notification. Non-material changes or clarifications will take effect immediately. You should periodically check the Site and this privacy page for updates.</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1">
              <span class="c0">VII. &nbsp;&nbsp;&nbsp;&nbsp;CONTACT US</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <p class="c1">
              <span
                class="c0"
              >If you have any questions regarding this Privacy Policy or the practices of this Site, please contact us by sending an email to legal@chorechampionapp.com.</span>
            </p>
            <p class="c1">
              <span class="c0">Last Updated: This Privacy Policy was last updated on 2/23/2019.</span>
            </p>
            <p class="c1">
              <span class="c0">&nbsp;</span>
            </p>
            <p class="c1 c2">
              <span class="c0"></span>
            </p>
            <div>
              <p class="c2 c5">
                <span class="c9"></span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SettingButton from "../components/SettingButton";
export default {
  name: "HelpSupport",
  components: { SettingButton },
};
</script>

<style scoped>
.lst-kix_1la9dngy1alt-6 > li {
  counter-increment: lst-ctn-kix_1la9dngy1alt-6;
}

ol.lst-kix_f5r12s34v82u-7.start {
  counter-reset: lst-ctn-kix_f5r12s34v82u-7 0;
}

ol.lst-kix_p1hetxp8f0u8-6.start {
  counter-reset: lst-ctn-kix_p1hetxp8f0u8-6 0;
}

.lst-kix_f5r12s34v82u-4 > li {
  counter-increment: lst-ctn-kix_f5r12s34v82u-4;
}

ol.lst-kix_906f9t5mooxm-2.start {
  counter-reset: lst-ctn-kix_906f9t5mooxm-2 0;
}

.lst-kix_1la9dngy1alt-5 > li {
  counter-increment: lst-ctn-kix_1la9dngy1alt-5;
}

.lst-kix_1la9dngy1alt-8 > li {
  counter-increment: lst-ctn-kix_1la9dngy1alt-8;
}

.lst-kix_1la9dngy1alt-0 > li:before {
  content: "" counter(lst-ctn-kix_1la9dngy1alt-0, decimal) ". ";
}

.lst-kix_1la9dngy1alt-2 > li:before {
  content: "" counter(lst-ctn-kix_1la9dngy1alt-2, lower-roman) ". ";
}

ol.lst-kix_f5r12s34v82u-4.start {
  counter-reset: lst-ctn-kix_f5r12s34v82u-4 0;
}

.lst-kix_1la9dngy1alt-3 > li:before {
  content: "" counter(lst-ctn-kix_1la9dngy1alt-3, decimal) ". ";
}

.lst-kix_f5r12s34v82u-3 > li {
  counter-increment: lst-ctn-kix_f5r12s34v82u-3;
}

.lst-kix_906f9t5mooxm-8 > li {
  counter-increment: lst-ctn-kix_906f9t5mooxm-8;
}

ol.lst-kix_p1hetxp8f0u8-3.start {
  counter-reset: lst-ctn-kix_p1hetxp8f0u8-3 0;
}

.lst-kix_1la9dngy1alt-1 > li:before {
  content: "" counter(lst-ctn-kix_1la9dngy1alt-1, lower-latin) ". ";
}

ol.lst-kix_f5r12s34v82u-1.start {
  counter-reset: lst-ctn-kix_f5r12s34v82u-1 0;
}

ol.lst-kix_p1hetxp8f0u8-0.start {
  counter-reset: lst-ctn-kix_p1hetxp8f0u8-0 0;
}

.lst-kix_p1hetxp8f0u8-0 > li {
  counter-increment: lst-ctn-kix_p1hetxp8f0u8-0;
}

ol.lst-kix_1la9dngy1alt-2.start {
  counter-reset: lst-ctn-kix_1la9dngy1alt-2 0;
}

.lst-kix_f5r12s34v82u-6 > li {
  counter-increment: lst-ctn-kix_f5r12s34v82u-6;
}

.lst-kix_f5r12s34v82u-2 > li:before {
  content: "" counter(lst-ctn-kix_f5r12s34v82u-2, lower-roman) ". ";
}

.lst-kix_f5r12s34v82u-4 > li:before {
  content: "" counter(lst-ctn-kix_f5r12s34v82u-4, lower-latin) ". ";
}

.lst-kix_906f9t5mooxm-6 > li {
  counter-increment: lst-ctn-kix_906f9t5mooxm-6;
}

.lst-kix_f5r12s34v82u-1 > li:before {
  content: "" counter(lst-ctn-kix_f5r12s34v82u-1, lower-latin) ". ";
}

.lst-kix_f5r12s34v82u-5 > li:before {
  content: "" counter(lst-ctn-kix_f5r12s34v82u-5, lower-roman) ". ";
}

.lst-kix_906f9t5mooxm-0 > li {
  counter-increment: lst-ctn-kix_906f9t5mooxm-0;
}

ol.lst-kix_f5r12s34v82u-5.start {
  counter-reset: lst-ctn-kix_f5r12s34v82u-5 0;
}

.lst-kix_f5r12s34v82u-3 > li:before {
  content: "" counter(lst-ctn-kix_f5r12s34v82u-3, decimal) ". ";
}

ol.lst-kix_p1hetxp8f0u8-5 {
  list-style-type: none;
}

ol.lst-kix_p1hetxp8f0u8-4 {
  list-style-type: none;
}

ol.lst-kix_p1hetxp8f0u8-7 {
  list-style-type: none;
}

.lst-kix_1la9dngy1alt-8 > li:before {
  content: "" counter(lst-ctn-kix_1la9dngy1alt-8, lower-roman) ". ";
}

.lst-kix_f5r12s34v82u-8 > li {
  counter-increment: lst-ctn-kix_f5r12s34v82u-8;
}

ol.lst-kix_p1hetxp8f0u8-6 {
  list-style-type: none;
}

ol.lst-kix_p1hetxp8f0u8-1 {
  list-style-type: none;
}

ol.lst-kix_p1hetxp8f0u8-0 {
  list-style-type: none;
}

ol.lst-kix_906f9t5mooxm-5.start {
  counter-reset: lst-ctn-kix_906f9t5mooxm-5 0;
}

ol.lst-kix_p1hetxp8f0u8-3 {
  list-style-type: none;
}

.lst-kix_1la9dngy1alt-7 > li:before {
  content: "" counter(lst-ctn-kix_1la9dngy1alt-7, lower-latin) ". ";
}

ol.lst-kix_p1hetxp8f0u8-2 {
  list-style-type: none;
}

ol.lst-kix_p1hetxp8f0u8-4.start {
  counter-reset: lst-ctn-kix_p1hetxp8f0u8-4 0;
}

.lst-kix_1la9dngy1alt-4 > li:before {
  content: "" counter(lst-ctn-kix_1la9dngy1alt-4, lower-latin) ". ";
}

.lst-kix_1la9dngy1alt-6 > li:before {
  content: "" counter(lst-ctn-kix_1la9dngy1alt-6, decimal) ". ";
}

ol.lst-kix_1la9dngy1alt-8.start {
  counter-reset: lst-ctn-kix_1la9dngy1alt-8 0;
}

.lst-kix_f5r12s34v82u-6 > li:before {
  content: "" counter(lst-ctn-kix_f5r12s34v82u-6, decimal) ". ";
}

.lst-kix_f5r12s34v82u-8 > li:before {
  content: "" counter(lst-ctn-kix_f5r12s34v82u-8, lower-roman) ". ";
}

ol.lst-kix_p1hetxp8f0u8-8 {
  list-style-type: none;
}

.lst-kix_1la9dngy1alt-5 > li:before {
  content: "" counter(lst-ctn-kix_1la9dngy1alt-5, lower-roman) ". ";
}

.lst-kix_f5r12s34v82u-7 > li:before {
  content: "" counter(lst-ctn-kix_f5r12s34v82u-7, lower-latin) ". ";
}

ol.lst-kix_f5r12s34v82u-8 {
  list-style-type: none;
}

ol.lst-kix_f5r12s34v82u-6 {
  list-style-type: none;
}

.lst-kix_p1hetxp8f0u8-1 > li {
  counter-increment: lst-ctn-kix_p1hetxp8f0u8-1;
}

ol.lst-kix_f5r12s34v82u-7 {
  list-style-type: none;
}

ol.lst-kix_f5r12s34v82u-4 {
  list-style-type: none;
}

ol.lst-kix_f5r12s34v82u-5 {
  list-style-type: none;
}

ol.lst-kix_1la9dngy1alt-1.start {
  counter-reset: lst-ctn-kix_1la9dngy1alt-1 0;
}

ol.lst-kix_f5r12s34v82u-2 {
  list-style-type: none;
}

ol.lst-kix_f5r12s34v82u-3 {
  list-style-type: none;
}

.lst-kix_f5r12s34v82u-5 > li {
  counter-increment: lst-ctn-kix_f5r12s34v82u-5;
}

ol.lst-kix_f5r12s34v82u-0 {
  list-style-type: none;
}

ol.lst-kix_f5r12s34v82u-1 {
  list-style-type: none;
}

ol.lst-kix_906f9t5mooxm-4.start {
  counter-reset: lst-ctn-kix_906f9t5mooxm-4 0;
}

.lst-kix_f5r12s34v82u-2 > li {
  counter-increment: lst-ctn-kix_f5r12s34v82u-2;
}

.lst-kix_p1hetxp8f0u8-7 > li {
  counter-increment: lst-ctn-kix_p1hetxp8f0u8-7;
}

.lst-kix_p1hetxp8f0u8-4 > li {
  counter-increment: lst-ctn-kix_p1hetxp8f0u8-4;
}

ol.lst-kix_1la9dngy1alt-8 {
  list-style-type: none;
}

ol.lst-kix_1la9dngy1alt-6 {
  list-style-type: none;
}

.lst-kix_1la9dngy1alt-4 > li {
  counter-increment: lst-ctn-kix_1la9dngy1alt-4;
}

ol.lst-kix_1la9dngy1alt-7 {
  list-style-type: none;
}

ol.lst-kix_f5r12s34v82u-6.start {
  counter-reset: lst-ctn-kix_f5r12s34v82u-6 0;
}

ol.lst-kix_1la9dngy1alt-4 {
  list-style-type: none;
}

ol.lst-kix_1la9dngy1alt-5 {
  list-style-type: none;
}

ol.lst-kix_1la9dngy1alt-7.start {
  counter-reset: lst-ctn-kix_1la9dngy1alt-7 0;
}

.lst-kix_f5r12s34v82u-0 > li:before {
  content: "" counter(lst-ctn-kix_f5r12s34v82u-0, decimal) ". ";
}

ol.lst-kix_1la9dngy1alt-2 {
  list-style-type: none;
}

ol.lst-kix_1la9dngy1alt-3 {
  list-style-type: none;
}

.lst-kix_1la9dngy1alt-7 > li {
  counter-increment: lst-ctn-kix_1la9dngy1alt-7;
}

ol.lst-kix_1la9dngy1alt-0 {
  list-style-type: none;
}

ol.lst-kix_1la9dngy1alt-1 {
  list-style-type: none;
}

ol.lst-kix_p1hetxp8f0u8-5.start {
  counter-reset: lst-ctn-kix_p1hetxp8f0u8-5 0;
}

ol.lst-kix_906f9t5mooxm-2 {
  list-style-type: none;
}

ol.lst-kix_1la9dngy1alt-0.start {
  counter-reset: lst-ctn-kix_1la9dngy1alt-0 0;
}

ol.lst-kix_906f9t5mooxm-3 {
  list-style-type: none;
}

ol.lst-kix_906f9t5mooxm-0 {
  list-style-type: none;
}

.lst-kix_p1hetxp8f0u8-5 > li {
  counter-increment: lst-ctn-kix_p1hetxp8f0u8-5;
}

ol.lst-kix_906f9t5mooxm-1 {
  list-style-type: none;
}

ol.lst-kix_906f9t5mooxm-6 {
  list-style-type: none;
}

.lst-kix_906f9t5mooxm-3 > li {
  counter-increment: lst-ctn-kix_906f9t5mooxm-3;
}

ol.lst-kix_906f9t5mooxm-7 {
  list-style-type: none;
}

ol.lst-kix_p1hetxp8f0u8-2.start {
  counter-reset: lst-ctn-kix_p1hetxp8f0u8-2 0;
}

ol.lst-kix_906f9t5mooxm-4 {
  list-style-type: none;
}

ol.lst-kix_906f9t5mooxm-5 {
  list-style-type: none;
}

.lst-kix_1la9dngy1alt-1 > li {
  counter-increment: lst-ctn-kix_1la9dngy1alt-1;
}

ol.lst-kix_f5r12s34v82u-0.start {
  counter-reset: lst-ctn-kix_f5r12s34v82u-0 0;
}

ol.lst-kix_1la9dngy1alt-3.start {
  counter-reset: lst-ctn-kix_1la9dngy1alt-3 0;
}

ol.lst-kix_906f9t5mooxm-8 {
  list-style-type: none;
}

.lst-kix_1la9dngy1alt-2 > li {
  counter-increment: lst-ctn-kix_1la9dngy1alt-2;
}

ol.lst-kix_1la9dngy1alt-6.start {
  counter-reset: lst-ctn-kix_1la9dngy1alt-6 0;
}

.lst-kix_906f9t5mooxm-0 > li:before {
  content: "" counter(lst-ctn-kix_906f9t5mooxm-0, decimal) ". ";
}

.lst-kix_p1hetxp8f0u8-0 > li:before {
  content: "" counter(lst-ctn-kix_p1hetxp8f0u8-0, decimal) ". ";
}

.lst-kix_p1hetxp8f0u8-1 > li:before {
  content: "" counter(lst-ctn-kix_p1hetxp8f0u8-1, lower-latin) ". ";
}

ol.lst-kix_906f9t5mooxm-0.start {
  counter-reset: lst-ctn-kix_906f9t5mooxm-0 0;
}

.lst-kix_906f9t5mooxm-2 > li {
  counter-increment: lst-ctn-kix_906f9t5mooxm-2;
}

.lst-kix_p1hetxp8f0u8-2 > li:before {
  content: "" counter(lst-ctn-kix_p1hetxp8f0u8-2, lower-roman) ". ";
}

.lst-kix_p1hetxp8f0u8-3 > li:before {
  content: "" counter(lst-ctn-kix_p1hetxp8f0u8-3, decimal) ". ";
}

.lst-kix_p1hetxp8f0u8-6 > li {
  counter-increment: lst-ctn-kix_p1hetxp8f0u8-6;
}

.lst-kix_p1hetxp8f0u8-3 > li {
  counter-increment: lst-ctn-kix_p1hetxp8f0u8-3;
}

.lst-kix_f5r12s34v82u-0 > li {
  counter-increment: lst-ctn-kix_f5r12s34v82u-0;
}

.lst-kix_906f9t5mooxm-5 > li {
  counter-increment: lst-ctn-kix_906f9t5mooxm-5;
}

.lst-kix_p1hetxp8f0u8-8 > li:before {
  content: "" counter(lst-ctn-kix_p1hetxp8f0u8-8, lower-roman) ". ";
}

ol.lst-kix_f5r12s34v82u-8.start {
  counter-reset: lst-ctn-kix_f5r12s34v82u-8 0;
}

ol.lst-kix_906f9t5mooxm-3.start {
  counter-reset: lst-ctn-kix_906f9t5mooxm-3 0;
}

.lst-kix_p1hetxp8f0u8-6 > li:before {
  content: "" counter(lst-ctn-kix_p1hetxp8f0u8-6, decimal) ". ";
}

.lst-kix_p1hetxp8f0u8-7 > li:before {
  content: "" counter(lst-ctn-kix_p1hetxp8f0u8-7, lower-latin) ". ";
}

.lst-kix_1la9dngy1alt-0 > li {
  counter-increment: lst-ctn-kix_1la9dngy1alt-0;
}

.lst-kix_p1hetxp8f0u8-4 > li:before {
  content: "" counter(lst-ctn-kix_p1hetxp8f0u8-4, lower-latin) ". ";
}

.lst-kix_p1hetxp8f0u8-5 > li:before {
  content: "" counter(lst-ctn-kix_p1hetxp8f0u8-5, lower-roman) ". ";
}

ol.lst-kix_906f9t5mooxm-6.start {
  counter-reset: lst-ctn-kix_906f9t5mooxm-6 0;
}

.lst-kix_p1hetxp8f0u8-2 > li {
  counter-increment: lst-ctn-kix_p1hetxp8f0u8-2;
}

ol.lst-kix_906f9t5mooxm-1.start {
  counter-reset: lst-ctn-kix_906f9t5mooxm-1 0;
}

.lst-kix_f5r12s34v82u-7 > li {
  counter-increment: lst-ctn-kix_f5r12s34v82u-7;
}

.lst-kix_p1hetxp8f0u8-8 > li {
  counter-increment: lst-ctn-kix_p1hetxp8f0u8-8;
}

ol.lst-kix_p1hetxp8f0u8-7.start {
  counter-reset: lst-ctn-kix_p1hetxp8f0u8-7 0;
}

.lst-kix_1la9dngy1alt-3 > li {
  counter-increment: lst-ctn-kix_1la9dngy1alt-3;
}

ol.lst-kix_1la9dngy1alt-5.start {
  counter-reset: lst-ctn-kix_1la9dngy1alt-5 0;
}

ol.lst-kix_906f9t5mooxm-8.start {
  counter-reset: lst-ctn-kix_906f9t5mooxm-8 0;
}

ol.lst-kix_p1hetxp8f0u8-1.start {
  counter-reset: lst-ctn-kix_p1hetxp8f0u8-1 0;
}

ol.lst-kix_f5r12s34v82u-2.start {
  counter-reset: lst-ctn-kix_f5r12s34v82u-2 0;
}

.lst-kix_f5r12s34v82u-1 > li {
  counter-increment: lst-ctn-kix_f5r12s34v82u-1;
}

.lst-kix_906f9t5mooxm-1 > li:before {
  content: "" counter(lst-ctn-kix_906f9t5mooxm-1, lower-latin) ". ";
}

.lst-kix_906f9t5mooxm-2 > li:before {
  content: "" counter(lst-ctn-kix_906f9t5mooxm-2, lower-roman) ". ";
}

.lst-kix_906f9t5mooxm-3 > li:before {
  content: "" counter(lst-ctn-kix_906f9t5mooxm-3, decimal) ". ";
}

ol.lst-kix_p1hetxp8f0u8-8.start {
  counter-reset: lst-ctn-kix_p1hetxp8f0u8-8 0;
}

ol.lst-kix_906f9t5mooxm-7.start {
  counter-reset: lst-ctn-kix_906f9t5mooxm-7 0;
}

.lst-kix_906f9t5mooxm-4 > li:before {
  content: "" counter(lst-ctn-kix_906f9t5mooxm-4, lower-latin) ". ";
}

.lst-kix_906f9t5mooxm-5 > li:before {
  content: "" counter(lst-ctn-kix_906f9t5mooxm-5, lower-roman) ". ";
}

.lst-kix_906f9t5mooxm-4 > li {
  counter-increment: lst-ctn-kix_906f9t5mooxm-4;
}

.lst-kix_906f9t5mooxm-1 > li {
  counter-increment: lst-ctn-kix_906f9t5mooxm-1;
}

.lst-kix_906f9t5mooxm-8 > li:before {
  content: "" counter(lst-ctn-kix_906f9t5mooxm-8, lower-roman) ". ";
}

.lst-kix_906f9t5mooxm-6 > li:before {
  content: "" counter(lst-ctn-kix_906f9t5mooxm-6, decimal) ". ";
}

.lst-kix_906f9t5mooxm-7 > li:before {
  content: "" counter(lst-ctn-kix_906f9t5mooxm-7, lower-latin) ". ";
}

ol.lst-kix_1la9dngy1alt-4.start {
  counter-reset: lst-ctn-kix_1la9dngy1alt-4 0;
}

.lst-kix_906f9t5mooxm-7 > li {
  counter-increment: lst-ctn-kix_906f9t5mooxm-7;
}

ol.lst-kix_f5r12s34v82u-3.start {
  counter-reset: lst-ctn-kix_f5r12s34v82u-3 0;
}

ol {
  margin: 0;
  padding: 0;
}

table td,
table th {
  padding: 0;
}

.c0 {
  color: var(--layout-color);
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Arial";
  font-style: normal;
}

.c4 {
  color: var(--layout-color);
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Arial";
  font-style: italic;
}

.c1 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: left;
  /* margin-right:67.5pt; */
}

.c9 {
  color: var(--layout-color);
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 9pt;
  font-family: "Arial";
  font-style: italic;
}

.c5 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.15;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.c8 {
  border-radius: var(--modal-radius);
  background-color: var(--layout-bg);
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 5%;
  text-align: center;
  overflow: scroll;
}

.c7 {
  margin-left: 49pt;
  text-indent: -14pt;
}

.c6 {
  text-indent: 36pt;
}

.c3 {
  font-weight: 700;
}

.c2 {
  height: 11pt;
}

.title {
  padding-top: 0pt;
  color: var(--layout-color);
  font-size: 26pt;
  padding-bottom: 3pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.subtitle {
  padding-top: 0pt;
  color: var(--layout-color);
  font-size: 15pt;
  padding-bottom: 16pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

li {
  color: var(--layout-color);
  font-size: 11pt;
  font-family: "Arial";
}

p {
  margin: 0;
  color: var(--layout-color);
  font-size: 11pt;
  font-family: "Arial";
}

h1 {
  padding-top: 20pt;
  color: var(--layout-color);
  font-size: 20pt;
  padding-bottom: 6pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h2 {
  padding-top: 18pt;
  color: var(--layout-color);
  font-size: 16pt;
  padding-bottom: 6pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h3 {
  padding-top: 16pt;
  color: var(--layout-color);
  font-size: 14pt;
  padding-bottom: 4pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h4 {
  padding-top: 14pt;
  color: var(--layout-color);
  font-size: 12pt;
  padding-bottom: 4pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h5 {
  padding-top: 12pt;
  color: var(--layout-color);
  font-size: 11pt;
  padding-bottom: 4pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h6 {
  padding-top: 12pt;
  color: var(--layout-color);
  font-size: 11pt;
  padding-bottom: 4pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  font-style: italic;
  orphans: 2;
  widows: 2;
  text-align: left;
}
</style>
